import type { ReportOrientation, SizePreset } from "store/types";

export interface PageMetrics {
  width: number;
  height: number;
  pdfOrientation: "portrait" | "landscape";
}

const PAGE_METRICS: Record<ReportOrientation, PageMetrics> = {
  portrait: {
    width: 794,
    height: 1123,
    pdfOrientation: "portrait",
  },
  landscape: {
    width: 1123,
    height: 794,
    pdfOrientation: "landscape",
  },
};

export function getPageMetrics(orientation: ReportOrientation): PageMetrics {
  return PAGE_METRICS[orientation];
}

// ─── Card sizing constants ──────────────────────────────────────────────────

export const MIN_CARD_WIDTH_PX = 160;

export const PRESET_WIDTHS: Record<SizePreset, number> = {
  S: 33.33,
  M: 50,
  F: 100,
};

// Content padding in PreviewMode (used for PDF calculations)
const PDF_CONTENT_PADDING = 96; // 48px * 2

export function pdfCardWidthPx(widthPercent: number, orientation: ReportOrientation): number {
  const { width: pageWidth } = getPageMetrics(orientation);
  return (widthPercent / 100) * (pageWidth - PDF_CONTENT_PADDING);
}

export function visibleColumnCount(
  widthPercent: number,
  orientation: ReportOrientation,
  columnMinWidths: number[],
): number {
  const available = pdfCardWidthPx(widthPercent, orientation);
  let total = 0;
  for (let i = 0; i < columnMinWidths.length; i++) {
    total += columnMinWidths[i];
    if (total > available) return i;
  }
  return columnMinWidths.length;
}

export function fittingPreset(remainingPercent: number): SizePreset | null {
  if (remainingPercent >= PRESET_WIDTHS.F) return "F";
  if (remainingPercent >= PRESET_WIDTHS.M) return "M";
  if (remainingPercent >= PRESET_WIDTHS.S) return "S";
  return null;
}

export function minWidthPercent(canvasWidthPx: number): number {
  return Math.round(((MIN_CARD_WIDTH_PX / canvasWidthPx) * 100) * 100) / 100;
}

export const PRESET_GRID_W: Record<SizePreset, number> = {
  S: 4,
  M: 6,
  F: 12,
};
